import React from 'react';
import Icon from 'components/Common/Icon';
import styles from './ModalComponent.scss';
import { ModalFooter, Props as FooterProps } from './ModalFooter';
import classnames from 'classnames';

interface Props {
  closeModal?: () => void;
  children: string | JSX.Element | JSX.Element[];
  isSaveButtonDisabled?: boolean;
  useSaveAsFormSubmit?: boolean;
  hideFooter?: boolean;
  hideSaveButton?: boolean;
  hideCloseButton?: boolean;
  onSave?: (payload?: object) => void;
  onCancel?: (payload?: object) => void;
  titleText?: string;
  closeText?: string;
  saveText?: string;
  className?: string;
  errorMessage?: string;
}

interface ComponentProps extends Props, FooterProps {}

class ModalComponent extends React.Component<ComponentProps> {

  private readonly myRef: React.RefObject<HTMLDivElement>;

  constructor(props: Props) {
    super(props);
    this.myRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside, true);
    document.addEventListener('keydown', this.handleCloseModal);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, true);
    document.removeEventListener('keydown', this.handleCloseModal);
  }

  handleClickOutside = (event: MouseEvent) => {
    const domNode = this.myRef.current;
    if (this.props.closeModal && domNode && !domNode.contains(event.target as Node)) {
      this.props.closeModal();
    }
  }

  handleCloseModal = (evt: KeyboardEvent) => {
    if (evt.code !== 'Escape') {
      return;
    }
    if (this.props.closeModal) {
      this.props.closeModal();
    }
  }

  render() {
    const {
      closeModal,
      titleText,
      hideFooter,
      className,
      errorMessage
    } = this.props;
    return (
      <div className={styles.container}>
        <div className={classnames(styles.content, className)} ref={this.myRef}>
          <button
            className={styles.closeButton}
            id="closeButton"
            name="btnClose"
            onClick={() => closeModal && closeModal()}
            role="button"
            type="button"
          >
            <Icon classes={['icon-cancel']} />
          </button>
          {
            titleText &&
            <div className={styles.title}>{titleText}</div>
          }
          <div className={styles.childrenContainer}>
            {this.props.children}
          </div>

          {hideFooter ? null : <ModalFooter {...this.props} />}

          {errorMessage ? <div className={styles.errorMessage}>{errorMessage}</div> : null}
        </div>
      </div>
    );
  }
}

export default ModalComponent;
